export default __webpack_public_path__ + "static/media/contact-bg.23ab6545.png";